import { render, staticRenderFns } from "./MFormVuetifyBranchPicker.vue?vue&type=template&id=6734ace6"
import script from "./MFormVuetifyBranchPicker.vue?vue&type=script&lang=js"
export * from "./MFormVuetifyBranchPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports